import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addDefaultLocale(en);

import React from "react";
import ReactTimeAgo from "react-time-ago";

import { StyledWrapper } from "./commentUserInfo.style";

const CommentUserInfo = ({ data }) => {
  const createdAtDate = data?.createdAtTimestamp || null;
  return (
    <StyledWrapper>
      <div>
        <div>{data?.commenterName}</div>
        <div>
          {createdAtDate && (
            <ReactTimeAgo date={createdAtDate} locale="en-US" />
          )}
        </div>
      </div>
      <img src={data?.commenterPic} alt="avatar" />
    </StyledWrapper>
  );
};

export default CommentUserInfo;
